import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../components/layout"
import TextBanner from "../components/text_banner"

import portrait_circle_1 from "../assets/images/protrait-circle-1.png"

function About() {
  return (
    <Layout>
      <Helmet>
        <title>InTouch Counselling Services - About</title>
        {/* <noscript> */}
          <link rel="stylesheet" href="assets/css/noscript.css" />
        {/* </noscript> */}
      </Helmet>

      <TextBanner
        quote="“You may not control all the events that happen to you, but you can decide not to be reduced by
        them.” – Maya Angelou"
      ></TextBanner>

      <section id="wrapper">
        <section id="one" className="wrapper spotlight style1 my-journey">
          <div className="inner">
            <div className="about-content">
              <h2>My Journey</h2>
              <a href="#one" className="avatar">
                <img src={portrait_circle_1} alt="" />
              </a>
              <p>
                My name is <strong>Tatiana Cabral</strong>. I am the owner and
                founder of InTouch Counselling Services. I am a member of the
                Canadian Positive Psychology Association. I am currently a
                Pre-Licensed Therapist and a Certified Coach Practitioner in
                process of completing my Registered Psychotherapist designation.
                I work in private practice in Mississauga, Ontario. I completed
                an an Existential Integrative Psychotherapy program at The
                Living Institute. I am truly passionate about helping you reach
                your own highest potential. I seek to live my life full of
                purpose and want my clients to attain the same by exploring and
                looking at their life’s unique story and help them reclaim
                freedom from obstacles that may be in the way of them becoming
                who they desire and want to become.
              </p>
              <p>
                My journey started in my early 20s as I opened to explore
                behaviors and beliefs that were negatively affecting and
                impacting my life. During this time, I was introduced to the
                idea of helping others through counselling, which began the deep
                process of uncovering those aspects that blocked my potential,
                my authenticity and living a more meaningful life. In addition
                to diving deeply into the path of counselling and internal
                self-reflection, the aspect of soul and essence became part of
                my path into a deeper understanding with myself.
              </p>
              <p>
                My calling to work in the field of counselling and interest in
                psychotherapy was motivated by my own life experience which led
                me to explore the workings of human behavior, emotions and mind.
                My motivation is greatly inspired in part by my own fruitful
                journey towards self-awareness. I can certainly empathize with
                all your fears, anxieties, insecurities, inner pains, traumas,
                struggles etc. One thing I know for certain is that I am
                entirely committed to help you attain the freedom from the
                struggles of day to day difficulties and you do not have to do
                it alone. If you have not received this support before allow me
                to be the first. I look forward to the opportunity to step into
                your life and see you blossom.
              </p>
              <p>
                This quest open me up to a level of internal self-reflection
                that was crucial to unlocking my authenticity, soul and
                self-empowerment. This was the initiation of my desire to help
                others awaken to their own authentic, empowered selves to live
                more meaningful lives. This exploration fascinated me and
                continues today. Life is a mystery and a continuous ongoing and
                unfolding exploration. My aim is to create a safe environment
                where you can share and dive into self-discovery, uncover and
                embrace all aspects of yourself. I will guide, support,
                encourage and even nudge you on your journey of self-exploration
                to help you discover more of you and hence a more meaningful
                life, one of self- acceptance, self-empowerment and more
                well-being……. A life of deeper connection and alignment to your
                essence self…… a life where your choices are aligned with your
                inner guidance!
              </p>
              <p style={{ textAlign: "center" }}>
                <strong>
                  “Bringing curiosity to the mystery that is life can make the
                  journey towards self-love a more lighthearted process.” – V.A.
                </strong>
              </p>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  )
}

export default About
